export default {
  data () {
    return {
      formFilters: {
        search: null,
        removedCategories: [],
        isBeta: false,
        isMaster: false,
        status: null
      }
    }
  },
  computed: {
    isSearching () {
      return !!this.formFilters.search
    },
    // Perform filtering on the result-set
    allCategories () {
      return this.getCategoriesForList(this.forms)
    },
    filteredResults () {
      const categories = {}
      const results = []

      const searchVal = (this.formFilters.search || '').toLowerCase()
      for (const item of this.forms) {
        if (this.formFilters.isMaster && !item.is_master) {
          continue
        }

        if (this.formFilters.isBeta && !item.is_beta) {
          continue
        }

        if (this.formFilters.status && item.status !== this.formFilters.status) {
          continue
        }

        if (!searchVal || ((item.title || '').toLowerCase().includes(searchVal) ||
          (item.standard || '').toLowerCase().includes(searchVal) ||
          (item.reference_id || '').toLowerCase().includes(searchVal))) {
          if (!this.formFilters.removedCategories.includes(item.category)) {
            results.push(item)
          }

          if (categories[item.category] === undefined) {
            categories[item.category] = 0
          }

          categories[item.category]++
        }
      }

      return {
        forms: results,
        categories
      }
    }
  },
  methods: {
    resetFilters () {
      this.formFilters.removedCategories = []
    },
    getCategoriesForList (list) {
      const arr = []
      for (const form of list) {
        const cat = form.category
        if (!arr.includes(cat)) {
          arr.push(cat)
        }
      }
      return arr.sort()
    },
    isCategoryDisabled (cat) {
      return this.formFilters.removedCategories.includes(cat)
    },
    toggleCategory (cat) {
      if (this.formFilters.removedCategories.length < 1) {
        this.formFilters.removedCategories = this.allCategories.filter(item => item !== cat)
        return
      }

      if (this.formFilters.removedCategories.includes(cat)) {
        this.formFilters.removedCategories.splice(this.formFilters.removedCategories.indexOf(cat), 1)
      }
      else {
        this.formFilters.removedCategories.push(cat)
      }

      // If has unselected all, automatically reselect all categories
      if (this.formFilters.removedCategories.length === this.allCategories.length) {
        this.formFilters.removedCategories = []
      }
    }
  }
}
